import React from 'react';
import { useNavigate } from 'react-router-dom';

// Hub for purchasing and dispatch-readiness pages.
const CARDS = [
  {
    path:        '/smart-buyer',
    icon:        '🛒',
    title:       'Smart Buyer',
    description: 'Manage automated purchase orders, fulfilment links, and supplier reordering.',
    accent:      'blue',
  },
  {
    path:        '/smart-buyer-dispatch',
    icon:        '✅',
    title:       'Smart Buyer — Ready to Dispatch',
    description: 'Smart Buyer orders where stock now covers every outstanding item — oldest order first.',
    accent:      'green',
  },
  {
    path:        '/general-stock-dispatch',
    icon:        '✅',
    title:       'Other Orders — Ready to Dispatch',
    description: 'Non-Smart-Buyer orders where stock now covers every outstanding item.',
    accent:      'green',
  },
  {
    path:        '/po-open-orders',
    icon:        '🔎',
    title:       'PO — Open Orders',
    description: 'For a PO number, every undispatched sales order holding one of its item codes. Select and print invoices.',
    accent:      'blue',
  },
  {
    path:        '/open-orders-list',
    icon:        '📋',
    title:       'Open Orders',
    description: 'The latest 100 undispatched sales orders, with a sales order filter. Select and print invoices.',
    accent:      'blue',
  },
  {
    path:        '/dispatch-tracking',
    icon:        '🚚',
    title:       'Dispatch Tracking',
    description: 'Shipments from Starshipit and Zappy: carrier, tracking number and status, plus Cin7 writeback issues. Search by order, customer or tracking no.',
    accent:      'blue',
  },
  {
    path:        '/po-landing',
    icon:        '📦',
    title:       'PO Landing Forecast',
    description: 'Units on open POs by predicted landing day over the next 4 weeks — see a big delivery coming and staff for it.',
    accent:      'gold',
  },
  {
    path:        '/invoices',
    icon:        '🧾',
    title:       'Invoice Archive',
    description: 'Every scanned supplier invoice — search by invoice number, supplier or order ref, see its Cin7 PO and view the scan. No Google login needed.',
    accent:      'blue',
  },
];

const DispatchTools = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
        <span className="page-nav__title">Dispatch Tools</span>
      </div>

      <div className="home-greeting">
        <p className="home-greeting__sub">Select a function to get started</p>
      </div>
      <div className="home-cards">
        {CARDS.map((card) => (
          <button
            key={card.path}
            className={`home-card home-card--${card.accent}`}
            onClick={() => navigate(card.path)}
          >
            <div className="home-card__icon">{card.icon}</div>
            <div className="home-card__body">
              <div className="home-card__title">{card.title}</div>
              <div className="home-card__desc">{card.description}</div>
            </div>
            <div className="home-card__arrow">→</div>
          </button>
        ))}
      </div>
    </main>
  );
};

export default DispatchTools;
